/*
 * This function can be used after making a request to the server which might return validation
 * errors.  If it finds any, it will throw a validation error which can be caught and handled in the client code.
 */
export function validationErrorCheck(response: Response) {
    return new Promise((resolve, reject) => {
        // A response can only be read once, so we'll clone it before reading
        const httpResponse = response.clone();
        httpResponse
            .json()
            .then((json) => {
                if (json.isValidationResult && !json.isValid) {
                    // @ts-ignore
                    reject(new ValidationError(json));
                } else {
                    resolve(response);
                }
            })
            .catch(() => {
                // ignore
            });
    });
}

/**
 * An Error object for server-side validation errors.
 *
 * @param {Response} validationResult - The validation response json from the server
 * @param {string} [message] - An optional message string for the error object.
 * @return {void}
 */
export function ValidationError(validationResult: any, message: string = 'Validation Error') {
    // @ts-ignore
    this.name = 'ValidationError';
    // @ts-ignore
    this.message = message;
    // @ts-ignore
    this.stack = new Error().stack;
    // @ts-ignore
    this.validationResult = validationResult;
}
ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;
